import firebase from "firebase/app";
import "firebase/auth";
const firebaseConfig = {
    apiKey: "AIzaSyAzagN63IlKeEYxz3rQEU1DajZrrPd6Jg8",
    authDomain: "b2c-web-full.firebaseapp.com",
    databaseURL: "https://b2c-web-full.firebaseio.com",
    projectId: "b2c-web-full",
    storageBucket: "b2c-web-full.appspot.com",
    messagingSenderId: "182070279194",
    appId: "1:182070279194:web:92698807e689c933c3e5a3"
};
// Initialize Firebase
const firebaseIni = firebase.initializeApp(firebaseConfig);
const firebaseAuth = firebaseIni.auth();
const gProvider = new firebase.auth.GoogleAuthProvider();

export default firebaseAuth
export { gProvider, firebaseIni };
